import jsonFetch from './json-fetch';

/*
 * Please keep this file as simple as possible. The `SCS API` should return raw responses.
 * If there is a need for normalization, perform that in the `SCS Client` file/module.
 */

let apiOrigin = '';

/**
 * Validate that either the `origin` argument or the global `apiOrigin` value have a truthy value
 *
 * @memberof scsApi
 * @param {String} [origin]
 * @throws Error for non-truthy API
 */
export function validateApiOrigin(origin) {
	origin = origin || apiOrigin;
	if (!origin || !origin.length) {
		apiOriginError(origin);
	}
}

function apiOriginError(origin) {
	let err = `SCSAPI ERROR: Invalid apiOrigin: ${origin}`;
	if (process.env.NODE_ENV !== 'production') {
		throw new Error(err);
	}
	else {
		console.error(err);
	}
}

function trimSlash(url) {
	if (url && url.charAt(url.length - 1) === '/') {
		url = url.substr(0, url.length - 1);
	}

	return url;
}

/**
 * Set the global `apiOrigin` that will be used in {@link fetchSCS} calls if origin is not supplied
 *
 * @memberof scsApi
 * @param {String} url
 * @throws  Error for non-truthy `url` value
 */
export function setApiOrigin(url) {
	apiOrigin = trimSlash(url);
	validateApiOrigin();
}

/**
 * Get the globally stored value of `apiOrigin`
 * @memberof scsApi
 * @returns {String}
 */
export function getApiOrigin() {
	return apiOrigin;
}

function getSiteHeader(site) {
	return { headers: { site } };
}

/**
 * Call the Synacor Content Service at `origin/path` with `site` specified in the `site` http header.
 * The response body will be turned into an object from the JSON result
 *
 * @memberof scsApi
 *
 * @param {String} path
 * @param {String} site
 * @param {String} [origin=apiOrigin] Will use global `apiOrigin` if not specified
 * @returns {Promise<Object>} JSON result already parsed into an `Object`
 */
export function fetchSCS(path, site, origin) {
	origin = origin ? trimSlash(origin) : apiOrigin;
	validateApiOrigin(origin);
	return jsonFetch(`${origin}${path}`, getSiteHeader(site));
}

/**
 * Named export with several functions that encapsulate functionality related to making calls to the Synacor Content Service (SCS)
 *
 * @namespace scsApi
 */
export default { validateApiOrigin, setApiOrigin, getApiOrigin, fetchSCS };
